import React from "react";

import ScrollAnimation from "react-animate-on-scroll";
import LargeHeroBanner from "components/large_hero_banner";
import Contact1 from "components/contact_1";
import CTABar2 from "components/cta_bar_2";

const ContactPage = () => {
  return (
    <>
      {/* <div id="header-area-space" className="slider-area bg-light-primary">
        <LargeHeroBanner bgImage={"/img/banner/contact_us_banner.jpg"}>
          <h2>
            <strong>Contact Us</strong>
          </h2>
          <br />
          <h2>Your Insurance and Risk Specialists</h2>
          <br />
        </LargeHeroBanner>
      </div> */}

      {/* Lead Capture */}
      <Contact1 bgOverride={"/img/banner/contact_us_banner.jpg"} />

      <CTABar2 />

      <section className="section-space-default-less38 bg-light-primary100">
        <div className="container">
          <div className="section-heading text-left heading-dark heading-layout1">
            <ScrollAnimation animateIn="fadeInUp" animateOnce>
              <h3
                style={{ fontWeight: "300", textTransform: "none" }}
                className=""
              >
                Our experienced team of insurance and risk professionals are
                only a moment away.
              </h3>
            </ScrollAnimation>
            <br />
            <br />
            <br />
            <div style={{ fontWeight: "300" }}>
              <ScrollAnimation animateIn="fadeInUp" animateOnce>
                <p>
                  We’re here to support you in protecting your business!
                  <br /> Please get in touch by either calling us directly{" "}
                  <a href="tel:+611300906963">1300 906 963</a> between 9-5 AEST
                  from monday to friday, by emailing{" "}
                  <a href="mailto:contact@finsteadrs.com.au">
                    contact@finsteadrs.com.au
                  </a>{" "}
                  or by using the form above.
                </p>
              </ScrollAnimation>
              <br />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactPage;
